// Helper functions for postMessage
export function addMessageListener(listener: (event: MessageEvent) => void) {
    window.addEventListener("message", listener);
}

export function removeMessageListener(listener: (event: MessageEvent) => void) {
    window.removeEventListener("message", listener);
}

